export const PORTFOLIO = {
  title: 'Portfolio',
  subtitle: 'My',
  typeWriter: ['Best Works', 'Latest Projects'],
  github: 'https://github.com/codeernoyon',
  types: ['All', 'Website', 'Mobile App', 'UI/UX Design', 'Graphic Design'],
  projects: [
    {
      title: 'Screen Shot app',
      description:
        'This is a screen shot app',
      video:'',
      images: {
        default: '/Asset/portfolio/screenShot-app.png',
        variants: [
          '/Asset/portfolio/screenShot-app.png',
          '/Asset/portfolio/screenShot-app.png',
        ],
      },
      link: 'https://screen-shot.netlify.app/',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Daraz clone',
      description:
        'Daraz is a e-commerce web site.',
      video: '',
      images: {
        default: '/Asset/portfolio/daraz-clon.png',
        variants: [
          '/Asset/portfolio/daraz-clon.png',
          '/Asset/portfolio/daraz-clon.png',
        ],
      },
      link: 'https://daraz-clon.netlify.app/',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Unsplash Clone',
      description:
        'Clone Unsplash',
      images: {
        default: '/Asset/portfolio/unsplash-clon.png',
        variants: [
          '/Asset/portfolio/unsplash-clon.png',
          '/Asset/portfolio/unsplash-clon.png',
        ],
      },
      link: 'https://unsplash-clon.netlify.app/',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Music App',
      description:
        'Music app',
      video: null,
      images: {
        default: '/Asset/portfolio/musice-app.png',
        variants: [
          '/Asset/portfolio/musice-app.png',
          '/Asset/portfolio/musice-app.png',
        ],
      },
      link: 'https://play-music-player.netlify.app/',
      type: 'Mobile App',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Git Hub repo search',
      description:
        'Git hub repo search',
      video: null,
      images: {
        default: '/Asset/portfolio/gitHub-search.png',
        variants: [
          '/Asset/portfolio/gitHub-search.png',
          '/Asset/portfolio/gitHub-search.png',
        ],
      },
      link: 'https://github-accounts-search.netlify.app/',
      type: 'Website',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
    {
      title: 'Bash Landing Page',
      description:
        'Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      video: null,
      images: {
        default: '/Asset/portfolio/visco-landing-page-1.png',
        variants: [
          '/Asset/portfolio/visco-landing-page-1.png',
          '/Asset/portfolio/visco-landing-page-1.png',
        ],
      },
      link: 'https://ksdevware.com',
      type: 'Graphic Design',
      tags: ['Web Design', 'Graphic Design', 'Mobile Apps'],
    },
  ],
};
